import React, { useEffect, useRef, useState } from "react";
import * as notify from "../../../../../shared/notify";

import Header from "../../nutritionpanel/components/header";
import Footnotes from "../../nutritionpanel/components/footnotes";
import Ingredients from "../../nutritionpanel/components/ingredients";
import AllergyInfo from "../../nutritionpanel/components/allergy-info";
import HealthClaims from "../../nutritionpanel/components/health-claims";
import AnalysisItemList from "./analysis-item-list";

import { Input, Measurement } from "../../../../form-inputs/inputs";
import { noteMarkList } from "../../nutritionpanel/lib/constants";

import { getPicklist } from "../../nutritionpanel/lib/data";

const Panel = (props) => {
    const panelRef = useRef();
    const [allergenOptions, setAllergenOptions] = useState([]);
    const [healthClaimOptions, setHealthClaimOptions] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const allergens = await getPicklist("Allergens");
            const healthClaims = await getPicklist("HealthClaims");

            if (!allergens || !healthClaims) {
                return;
            }

            setAllergenOptions(allergens);
            setHealthClaimOptions(healthClaims);
        }

        fetchData();
    }, []);

    const removePanel = async () => {
        if (await notify.confirm("Are you sure you want to delete this panel?")) {
            props.removePanel();

            if (panelRef.current) {
                panelRef.current.focus();
            }
        }
    };

    const panel = props.panel;

    return (
        <div ref={panelRef} className="guaranteed-analysis">
            <div className="panel">
                <div className="button-group">
                    <h2>
                        Guaranteed Analysis{" "}
                        <button className="button -text -small" onClick={removePanel}>
                            Delete Panel
                        </button>
                    </h2>
                </div>

                <div className="panel-group">
                    <Header value={panel.header} updateField={props.updateField} />
                    <Measurement name="servingSize" label="Serving Size" defaultValue={panel.servingSize} updateOnChange={props.updateField} />
                    <Input name="servingsPerContainer" label="Servings Per Container" value={panel.servingsPerContainer} updateOnChange={props.updateField} />
                </div>

                <AnalysisItemList data={panel.analysis} updateField={props.updateField} updateFieldDeep={props.updateFieldDeep} addColumn={props.addColumn} removeColumn={props.removeColumn} />
                <Footnotes data={panel.footnotes} noteMarkList={noteMarkList} updateField={props.updateField} />
                <Ingredients data={panel.ingredients} updateField={props.updateFieldDeep} />

                <div className="panel-group">
                    <h3>Other Information</h3>
                    <Input name="calorieContent" label="Calorie Content" value={panel.calorieContent} updateOnChange={props.updateField} />
                    <Input name="aafcoStatement" label="AAFCO Statement" value={panel.aafcoStatement} updateOnChange={props.updateField} />
                </div>

                {panel.healthClaims && <HealthClaims data={panel.healthClaims} allergenOptions={allergenOptions} healthClaimOptions={healthClaimOptions} allergens={panel.allergens} updateField={props.updateField} />}
                {panel.allergens && <AllergyInfo data={panel.allergens} allergenOptions={allergenOptions} updateField={props.updateField} />}
            </div>
        </div>
    );
};

export default Panel;
